import Root from '../../Presentation/Pages/RootLayout';
import Home from '../../Presentation/Pages/Home';
import { createBrowserRouter } from 'react-router';
import Signup from '../../Presentation/Pages/Signup';
import Login from '../../Presentation/Pages/Login';
import AuthLayout from '../../Presentation/Pages/AuthLayout';
import OurProducts from '../../Presentation/Pages/OurProducts';
import SingleProduct from '../../Presentation/Pages/SingleProduct';
import { ChangePassword } from '../../Presentation/Pages/ChangePassword';
import ContactPage from '../../Presentation/Pages/ContactPage';
import CartPage from '../../Presentation/Components/Cart/CartPage';
import AboutUsPage from '../../Presentation/Pages/AboutUsPage';
import { ForgetPassword } from '../../Presentation/Pages/ForgetPassword';
import { ResetPassword } from '../../Presentation/Pages/ResetPassword';
import { Verification } from '../../Presentation/Pages/Verification';
import AddCategory from '../../Presentation/Pages/Admin/AddCategory';
import ManageCategories from '../../Presentation/Pages/Admin/ManageCategories';
import AdminLayout from '../../Presentation/Pages/Admin/AdminLayout';
import ContactInquiriesPage from '../../Presentation/Pages/ContactInquiriesPage';
import ManageDepartments from '../../Presentation/Pages/Admin/ManageDepartments';
import NotFoundPage from '../../Presentation/Pages/NotFoundPage';
import ProfilePage from '../../Presentation/Pages/ProfilePage';
import NewsletterUnsubscribePage from '../../Presentation/Components/Home/NewsletterUnsubscribePage';
import CheckoutPage from '../../Presentation/Components/Checkout/CheckoutPage';
import ManageProductsPage from '../../Presentation/Pages/Admin/ManageProductsPage';
import AddProduct from '../../Presentation/Pages/Admin/AddProduct';
import EditCategory from '../../Presentation/Pages/Admin/EditCategory';
import EditProductPage from '../../Presentation/Pages/Admin/EditProductPage';
import OrderSuccessPage from '../../Presentation/Components/Checkout/OrderSuccessPage';
import MyOrdersPage from '../../Presentation/Components/Orders/MyOrdersPage';
import OrderDetailsPage from '../../Presentation/Components/Orders/OrderDetailsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Root,
    children: [
      { index: true, Component: Home },
      { path: 'products', Component: OurProducts },
      { path: 'products/:slug', Component: SingleProduct },
      { path: 'contact', Component: ContactPage },
      { path: 'cart', Component: CartPage },
      { path: 'checkout', Component: CheckoutPage },
      { path: 'about', Component: AboutUsPage },
      { path: 'newsleter-unsubscribe/:email', Component: NewsletterUnsubscribePage },
      { path: 'order-success', Component: OrderSuccessPage },
      { path: 'my-orders', Component: MyOrdersPage },
      { path: '/orders/:id', Component: OrderDetailsPage },
      { path: '*', Component: NotFoundPage },

      {
        path: 'auth',
        Component: AuthLayout,
        children: [
          { path: 'login', Component: Login },
          { path: 'signup', Component: Signup },
          { path: 'change-password', Component: ChangePassword },
          { path: 'forget-password', Component: ForgetPassword },
          { path: 'reset-password/:email', Component: ResetPassword },
          { path: 'verification', Component: Verification },
          { path: 'profile', Component: ProfilePage },
        ],
      },
      {
        path: 'admin',
        Component: AdminLayout,
        children: [
          { path: 'new-categories', Component: AddCategory },
          { path: 'manage-categories', Component: ManageCategories },
          { path: 'inquiries', Component: ContactInquiriesPage },
          { path: 'departments', Component: ManageDepartments },
          { path: 'categories/:categorySlug/products', Component: ManageProductsPage },
          { path: 'categories/:categoryId/new-product', Component: AddProduct },
          { path: 'categories/:slug/edit', Component: EditCategory },
          { path: 'products/:slug/edit', Component: EditProductPage },
        ],
      },
    ],
  },
]);
